// VehicleReport.js

import React from "react";
import "../components/Styles/VehicleReport.css";
import { FaStar } from "react-icons/fa";

function VehicleReport() {

  return (

    <>

      {/* =========================
          HERO SECTION
      ========================= */}

      <section className="vehicle-hero">

        <div className="container vehicle-container">

          {/* LEFT */}

          <div className="vehicle-left">

            <span className="top-tag">
              #1 Trusted Vehicle Verification Platform
            </span>

            <h1>
              Buying A <span>Second Hand</span> Car Or Bike?
            </h1>

            <h3>
              Don't Get Scammed. Check The Legal History First.
            </h3>

            <p>
              Verify vehicle ownership, challans, accidental records,
              insurance status, blacklist data and complete legal history
              instantly before purchasing any used vehicle.
            </p>

            {/* REPORT BOX */}

            <div className="report-box">

              <small>
                Get Vehicle Legal History
              </small>

              {/* REVIEW */}

              <div className="review-box">

                <div className="stars">

                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />

                </div>

                <span>
                  4.9 Rating (12k+ Reviews)
                </span>

              </div>

              {/* FORM */}

              <div className="report-form">

                <select>

                  <option>IND</option>
                  <option>USA</option>
                  <option>UAE</option>

                </select>

                <input
                  type="text"
                  placeholder="Enter Vehicle Number"
                />

                <button>
                  Get Detail Report
                </button>

              </div>

            </div>

          </div>

          {/* RIGHT IMAGE */}

          <div className="vehicle-right">

            <img
              src="https://img.freepik.com/free-vector/car-dealer-concept-illustration_114360-7986.jpg"
              alt=""
            />

          </div>

        </div>

      </section>


      {/* =========================
          HOW TO CHECK REPORT
      ========================= */}

      <section className="how-report-section">

        <div className="container">

          <div className="section-title">

            <h2>
              How To Check <span>Vehicle Legal Report</span>
            </h2>

            <p>
              Follow these simple steps to instantly verify any vehicle’s
              legal history, ownership details, insurance records,
              challans, blacklist status and more before buying.
            </p>

          </div>

          {/* STEPS GRID */}

          <div className="steps-grid">

            {/* STEP 1 */}

            <div className="step-card">

              <div className="step-number">
                Step 01
              </div>

              <h3>
                Enter Vehicle Number
              </h3>

              <p>
                Type your vehicle registration number carefully in the
                search box to begin the verification process.
              </p>

            </div>

            {/* STEP 2 */}

            <div className="step-card">

              <div className="step-number">
                Step 02
              </div>

              <h3>
                Select Country
              </h3>

              <p>
                Choose your country from the dropdown menu so the
                system can fetch accurate vehicle records.
              </p>

            </div>

            {/* STEP 3 */}

            <div className="step-card">

              <div className="step-number">
                Step 03
              </div>

              <h3>
                Generate Report
              </h3>

              <p>
                Click on the “Get Detail Report” button to instantly
                process and generate the legal vehicle report.
              </p>

            </div>

            {/* STEP 4 */}

            <div className="step-card">

              <div className="step-number">
                Step 04
              </div>

              <h3>
                View Full Legal History
              </h3>

              <p>
                Check ownership details, challans, accident history,
                insurance status and blacklist records securely.
              </p>

            </div>

          </div>

        </div>

      </section>

      {/* =========================
    WHAT IS VEHICLE REPORT
========================= */}

<section className="vehicle-report-info">

  <div className="container">

    <div className="section-title">

      <h2>
        What Is A <span>Vehicle Legal Report?</span>
      </h2>

      <p>
        A vehicle legal report helps buyers verify the complete legal,
        financial and ownership history of any used vehicle before purchasing.
      </p>

    </div>

    <div className="report-info-grid">

      {/* CARD 1 */}

      <div className="info-card">

        <h3>
          Ownership Details
        </h3>

        <p>
          Check the real owner name, registration information
          and transfer history of the vehicle.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="info-card">

        <h3>
          Challan Records
        </h3>

        <p>
          View pending traffic challans, fines and legal
          penalties linked with the vehicle.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="info-card">

        <h3>
          Accident History
        </h3>

        <p>
          Verify whether the vehicle has been involved
          in any major accidents or insurance claims.
        </p>

      </div>

      {/* CARD 4 */}

      <div className="info-card">

        <h3>
          Insurance Status
        </h3>

        <p>
          Check current insurance validity,
          expiry date and policy information.
        </p>

      </div>

      {/* CARD 5 */}

      <div className="info-card">

        <h3>
          Blacklist Verification
        </h3>

        <p>
          Detect if the vehicle is blacklisted,
          stolen or involved in suspicious activity.
        </p>

      </div>

      {/* CARD 6 */}

      <div className="info-card">

        <h3>
          Loan / RC Status
        </h3>

        <p>
          Find out whether the vehicle has any
          active loan, hypothecation or RC issue.
        </p>

      </div>

    </div>

  </div>

</section>

{/* =========================
    RISK SECTION
========================= */}

<section className="risk-section">

  <div className="container">

    <div className="section-title">

      <h2>
        The Risks Of Skipping <span>Vehicle Legal Report</span>
      </h2>

      <p>
        Ignoring a vehicle legal report before buying a used vehicle
        can lead to serious financial, legal and safety problems later.
      </p>

    </div>

    <div className="risk-grid">

      {/* CARD 1 */}

      <div className="risk-card">

        <div className="risk-icon">
          ⚠️
        </div>

        <h3>
          Hidden Challans
        </h3>

        <p>
          You may unknowingly purchase a vehicle with unpaid traffic
          fines and legal penalties.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="risk-card">

        <div className="risk-icon">
          🚨
        </div>

        <h3>
          Stolen Vehicle Risk
        </h3>

        <p>
          Without verification, you could buy a blacklisted or stolen
          vehicle and face legal action.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="risk-card">

        <div className="risk-icon">
          💥
        </div>

        <h3>
          Accident Damage
        </h3>

        <p>
          The vehicle may have hidden accident history or major damage
          not disclosed by the seller.
        </p>

      </div>

      {/* CARD 4 */}

      <div className="risk-card">

        <div className="risk-icon">
          💰
        </div>

        <h3>
          Pending Loan Issues
        </h3>

        <p>
          Some vehicles may still have active loans or hypothecation
          problems attached to them.
        </p>

      </div>

      {/* CARD 5 */}

      <div className="risk-card">

        <div className="risk-icon">
          📄
        </div>

        <h3>
          Fake Documents
        </h3>

        <p>
          Sellers may provide forged RC, insurance or ownership
          documents to scam buyers.
        </p>

      </div>

      {/* CARD 6 */}

      <div className="risk-card">

        <div className="risk-icon">
          ❌
        </div>

        <h3>
          Financial Loss
        </h3>

        <p>
          Buying an unverified vehicle can result in huge repair,
          legal and resale losses.
        </p>

      </div>

    </div>

  </div>

</section>

{/* =========================
    REAL NUMBERS SECTION
========================= */}

<section className="real-impact-section">

  <div className="container">

    <div className="section-title">

      <h2>
        Real Numbers, <span>Real Impact</span>
      </h2>

      <p>
        Thousands of users trust our platform daily to verify used
        vehicles and avoid fraud before purchasing.
      </p>

    </div>

    <div className="impact-grid">

      {/* BOX 1 */}

      <div className="impact-card">

        <h3>
          50K+
        </h3>

        <p>
          Vehicle Reports Generated
        </p>

      </div>

      {/* BOX 2 */}

      <div className="impact-card">

        <h3>
          20K+
        </h3>

        <p>
          Fraud Vehicles Detected
        </p>

      </div>

      {/* BOX 3 */}

      <div className="impact-card">

        <h3>
          98%
        </h3>

        <p>
          Customer Satisfaction Rate
        </p>

      </div>

      {/* BOX 4 */}

      <div className="impact-card">

        <h3>
          15K+
        </h3>

        <p>
          Happy Vehicle Buyers
        </p>

      </div>

    </div>

  </div>

</section>

{/* =========================
    KEY INFORMATION SECTION
========================= */}

<section className="info-report-section">

  <div className="container">

    <div className="section-title">

      <h2>
        What Key Information Does A
        <span> Vehicle Legal Report </span>
        Provide?
      </h2>

      <p>
        A complete vehicle legal report helps buyers verify ownership,
        insurance, loan status, accidental records and other important
        details before purchasing any used vehicle.
      </p>

    </div>

    <div className="info-grid">

      {/* CARD 1 */}

      <div className="info-card">

        <div className="info-icon">
          👤
        </div>

        <h3>
          Ownership Details
        </h3>

        <h4>
          What's Included
        </h4>

        <p>
          Owner name, registration details, RC status,
          transfer history and registration state.
        </p>

        <h4>
          Why It's Important
        </h4>

        <p>
          Helps verify whether the seller is genuine
          and prevents ownership fraud.
        </p>

      </div>

      {/* CARD 2 */}

      <div className="info-card">

        <div className="info-icon">
          🚗
        </div>

        <h3>
          Vehicle Details
        </h3>

        <h4>
          What's Included
        </h4>

        <p>
          Vehicle model, fuel type, engine number,
          chassis number and manufacturing year.
        </p>

        <h4>
          Why It's Important
        </h4>

        <p>
          Confirms whether vehicle information
          matches official government records.
        </p>

      </div>

      {/* CARD 3 */}

      <div className="info-card">

        <div className="info-icon">
          🏦
        </div>

        <h3>
          Loan & Finance Status
        </h3>

        <h4>
          What's Included
        </h4>

        <p>
          Active loan records, hypothecation details
          and bank finance information.
        </p>

        <h4>
          Why It's Important
        </h4>

        <p>
          Ensures the vehicle is not under unpaid
          loan or financial dispute.
        </p>

      </div>

      {/* CARD 4 */}

      <div className="info-card">

        <div className="info-icon">
          🛡️
        </div>

        <h3>
          Insurance Details
        </h3>

        <h4>
          What's Included
        </h4>

        <p>
          Insurance validity, provider details,
          expiry date and claim history.
        </p>

        <h4>
          Why It's Important
        </h4>

        <p>
          Prevents future legal issues and helps
          buyers know the insurance status.
        </p>

      </div>

      {/* CARD 5 */}

      <div className="info-card">

        <div className="info-icon">
          ⚠️
        </div>

        <h3>
          Challan & Blacklist Records
        </h3>

        <h4>
          What's Included
        </h4>

        <p>
          Pending challans, traffic violations,
          blacklist records and police alerts.
        </p>

        <h4>
          Why It's Important
        </h4>

        <p>
          Helps avoid vehicles involved in illegal
          activities or unpaid fines.
        </p>

      </div>

      {/* CARD 6 */}

      <div className="info-card">

        <div className="info-icon">
          🔧
        </div>

        <h3>
          Accident History
        </h3>

        <h4>
          What's Included
        </h4>

        <p>
          Accident reports, damage records and
          previous repair history if available.
        </p>

        <h4>
          Why It's Important
        </h4>

        <p>
          Helps buyers understand the actual
          condition and safety of the vehicle.
        </p>

      </div>

    </div>

  </div>

</section>

    </>

  );

}

export default VehicleReport;